export const INTERCEPT_STAMP = "WHAT YOUR CUSTOMER EXPERIENCES";
export const INTERCEPT_SCAN_TAG = "Sunday · 10 PM · Office closed";

export const INTERCEPT_HEADLINE = {
  lead: "Your Customers Feel Like",
  accent: "You're Always on the Line",
};

export const INTERCEPT_SUBHEAD =
  "They message when you're on a job or asleep. Your digital employee replies in seconds, asks the right questions, and books the inspection, before your competitor's voicemail picks up.";

export const INTERCEPT_CHAT = {
  statusTime: "10:14 PM",
  statusDay: "Sunday",
  businessName: "Oz Exteriors",
  messages: [
    {
      id: "customer-1",
      role: "customer",
      text: "Roof leaking badly, can someone come out tonight?",
    },
    {
      id: "ai-1",
      role: "ai",
      text: "Hi, I'm Alex with Oz Exteriors. I'm on it. What's your address, and is this a tile or metal roof?",
    },
    {
      id: "customer-2",
      role: "customer",
      text: "42 George St, tile, leak near the chimney",
    },
    {
      id: "ai-2",
      role: "ai",
      text: "Got it. Inspection booked Thu 9:00 AM ✓",
      highlight: true,
    },
  ],
};

export const INTERCEPT_BEATS = [
  {
    id: "when",
    value: "Sunday · 10:14 PM",
    detail: "Office closed. Your crew is asleep. Competitors are routing to voicemail.",
  },
  {
    id: "speed",
    value: "26 seconds",
    detail:
      'Vetted, qualified, and closed. Not a "we will call you back tomorrow" automated template.',
    highlight: true,
  },
  {
    id: "booked",
    value: "Booked ✓",
    detail:
      "The lead is locked into your calendar before your competitor even opens their eyes.",
    outcome: true,
  },
];

export const INTERCEPT_PAYOFF = {
  prefix: "Lead to booked inspection in",
  highlight: "26 seconds,",
  suffix: "while you sleep.",
};
